import SearchIcon from '@mui/icons-material/Search';
import { InputAdornment, TextField } from "@mui/material";
import { useIntl } from "react-intl";
import { debounce } from '../utils/lib';

export default function SearchField({ onChange, onEnter }) {

  const intl = useIntl();

  /**
   * Handle change with a debounce.
   */
  const handleChange = debounce(onChange);

  return (
    <TextField
      placeholder={intl.formatMessage({ id: "SearchField.search" })}
      type="search"
      variant="outlined"
      fullWidth
      size="small"
      onChange={(event) => handleChange(event.target.value)}
      onKeyDown={(event) => {
        if (onEnter) {
          if (event.code === "Enter") {
            onEnter(event.target.value);
            return;
          }
        }
        if (event.code === "Escape") {
          event.stopPropagation();
          // clear the search
          onChange("");
        }
      }}
      InputProps={{
        startAdornment: (
          <InputAdornment position="start">
            <SearchIcon />
          </InputAdornment>
        ),
      }}
    />
  );
}
